

    const piexif = {
        ExifIFD : {
            ColorSpace:40961,
            PixelXDimension:40962,
            PixelYDimension:40963,
        },
        ImageIFD: {
            XResolution: 282,
            YResolution: 283,
            ImageWidth: 256,
            ImageLength: 257,
            BitsPerSample: 258,
            CellWidth: 264,
            CellLength: 265,
            YCbCrCoefficients: 529,
            YCbCrPositioning: 531,
            YCbCrSubSampling: 530,
            Orientation: 274,

        }
    };

    export interface IPoint {
        x: number;
        y: number;
    }

    export interface ISize {
        width: number;
        height: number;
    }

    export interface ICrop extends IPoint {
        width: number;
        height: number;
    }

    export class ImagingUtils {

        public static getImageSizeFromMax(originalWidth: number, originalHeight: number, maxSize: number, outerWidth?: number, outerHeight?: number): ISize {
            let newWidth;
            let newHeight;
            if (outerWidth && outerHeight) {
                const zoomToFit = originalWidth / originalHeight > outerWidth / outerHeight ? outerWidth / originalWidth : outerHeight / originalHeight;
                newWidth = originalWidth * zoomToFit;
                newHeight = originalHeight * zoomToFit;
            } else {
                if (originalWidth > originalHeight) {
                    newWidth = maxSize;
                    newHeight = maxSize * (originalHeight / originalWidth);
                } else {
                    newHeight = maxSize;
                    newWidth = maxSize * (originalWidth / originalHeight);
                }
            }
            return {width: Math.round(newWidth), height: Math.round(newHeight)};

        }

        public static getScaledCrop(cropWidth: number, cropHeight: number, maxWidth: number, maxHeight: number): ICrop {
            const sourceRatio = cropWidth / cropHeight;
            const targetRatio = maxWidth / maxHeight;
            const scale = sourceRatio >= targetRatio ? maxHeight / cropHeight : maxWidth / cropWidth;
            return ImagingUtils.scaleCrop({
                width: cropWidth,
                height: cropHeight,
                x: 0,
                y: 0
            }, scale);
        }

        public static scaleCrop(crop: ICrop, scale: number): ICrop {
            return {
                x: Math.floor(crop.x * scale),
                y: Math.floor(crop.y * scale),
                width: Math.floor(crop.width * scale),
                height:Math.floor(crop.height * scale)
            };
        }

        public static isPhotoZone(freeObject: any): boolean {
            return !(freeObject.isBackground || freeObject.isClipArt || freeObject.textEdits);
        }

        public static drawImageWithCrop(source: HTMLCanvasElement | HTMLImageElement, crop: ICrop, sourceCrop: ICrop | null = null, quality:number = 80, outputFormat:string = 'jpg'): string | null {

            if (sourceCrop == null) {
                sourceCrop = crop;
            }
            const canvas = document.createElement('canvas');
            canvas.width = crop.width;
            canvas.height = crop.height;
            const context = canvas.getContext('2d');
            if (context) {
                let type:string;
                if (outputFormat === 'png' || outputFormat === 'txt') {
                    type = 'image/png';
                } else {
                    type = 'image/jpeg';
                    // If we are using jpeg, we need to set the background to be white.
                    context.fillStyle = '#ffffff';
                    context.fillRect(0, 0, canvas.width, canvas.height);
                }
                context.drawImage(source, sourceCrop.x, sourceCrop.y, sourceCrop.width, sourceCrop.height, 0, 0, crop.width, crop.height);
                return canvas.toDataURL(type, quality / 100);
            }
            return null;
        }

        protected static getZoomFromSize(width: number, height: number, size: ISize):number {
            const innerAspectRatio = size.width / size.height;
            const outerAspectRatio = width / height;

            let zoom;

            if (innerAspectRatio > outerAspectRatio) {
                zoom = width / size.width;
            } else {
                zoom = height / size.height;
            }

            return (1 / zoom) * 100;
        }

        public static getResizedImage(image: HTMLImageElement, maxSideSize:number): {dataUrl: string, size: ISize} {
            const originalImageSize = {width: image.width, height: image.height};
            let maxSize = this.getImageSizeFromMax(image.width, image.height, maxSideSize);
            if (maxSize.width > image.width || maxSize.height > image.height) {
                maxSize = originalImageSize;
            }

            const canvas = document.createElement('canvas');
            canvas.width = maxSize.width;
            canvas.height = maxSize.height;
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.drawImage(image, 0, 0, maxSize.width, maxSize.height);
            } else {
                console.error('Unable to get canvas context');
            }
            return {dataUrl: canvas.toDataURL('image/jpeg', 80), size: maxSize};

        }

        public static dataURLtoFile(dataurl: string, filename: string): File {
            const arr = dataurl.split(',');
            const mimeTypeMatch = arr[0].match(/:(.*?);/);
            const mime = mimeTypeMatch ? mimeTypeMatch[1] : 'image/jpeg';
            const u8arr = Uint8Array.from(atob(arr[1]), c => c.charCodeAt(0));
            return new File([u8arr], filename, {type: mime});
        }

        public static removeExifData(exifObject: any): void {
            delete exifObject['0th'][piexif.ImageIFD.XResolution];
            delete exifObject['0th'][piexif.ImageIFD.YResolution];
            delete exifObject['0th'][piexif.ImageIFD.ImageWidth];
            delete exifObject['0th'][piexif.ImageIFD.ImageLength];
            delete exifObject['0th'][piexif.ImageIFD.BitsPerSample];
            delete exifObject['0th'][piexif.ImageIFD.CellWidth];
            delete exifObject['0th'][piexif.ImageIFD.CellLength];
            delete exifObject['0th'][piexif.ImageIFD.YCbCrCoefficients];
            delete exifObject['0th'][piexif.ImageIFD.YCbCrSubSampling];
            delete exifObject['0th'][piexif.ImageIFD.YCbCrPositioning];
            delete exifObject['Exif'][piexif.ExifIFD.PixelXDimension];
            delete exifObject['Exif'][piexif.ExifIFD.PixelYDimension];
            delete exifObject['Exif'][piexif.ExifIFD.ColorSpace];
            delete exifObject['0th'][piexif.ImageIFD.Orientation];
        }
    }

